import * as React from 'react'

import { reportClientError } from '../../../../../../../../../app/_components/chrome/scripts/DataDogRumScript'

interface State {
  hasError: boolean
}

export class ProductGroupTileErrorBoundary extends React.Component<
  { children?: React.ReactNode },
  State
> {
  public static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  constructor(props: {}) {
    super(props)
    this.state = { hasError: false }
  }

  public render() {
    return this.state.hasError ? null : this.props.children
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public componentDidCatch(error: any): void {
    reportClientError({
      error,
      context: {
        scope: 'ProductGroupTileErrorBoundary',
      },
    })
  }
}
